/**
 * Calculs devis / proforma (alignés sur le moteur serveur).
 */

export type ProformaLineInput = {
  quantite: number;
  prixUnitaire: number;
  remise?: number;
};

export type ProformaTotals = {
  sousTotalBrut: number;
  remiseTotale: number;
  sousTotalHT: number;
  tva: number;
  totalTTC: number;
  netAPayer: number;
};

function round2(n: number): number {
  return Math.round(n * 100) / 100;
}

export function calculateLineTotal(line: ProformaLineInput): number {
  const q = Number(line.quantite) || 0;
  const pu = Number(line.prixUnitaire) || 0;
  const rem = Math.max(0, Number(line.remise ?? 0) || 0);
  const brut = q * pu;
  const remEff = Math.min(rem, brut);
  return round2(brut - remEff);
}

export function calculateProformaTotals(
  lines: ProformaLineInput[],
  tauxTvaPercent: number,
  options?: { exonereTva?: boolean }
): ProformaTotals {
  if (!lines.length) {
    return {
      sousTotalBrut: 0,
      remiseTotale: 0,
      sousTotalHT: 0,
      tva: 0,
      totalTTC: 0,
      netAPayer: 0,
    };
  }

  let sousTotalBrut = 0;
  let remiseTotale = 0;

  for (const line of lines) {
    const q = Number(line.quantite) || 0;
    const pu = Number(line.prixUnitaire) || 0;
    const rem = Math.max(0, Number(line.remise ?? 0) || 0);
    const brut = q * pu;
    const remEff = Math.min(rem, brut);
    sousTotalBrut += brut;
    remiseTotale += remEff;
  }

  const sousTotalHT = round2(sousTotalBrut - remiseTotale);
  const exo = Boolean(options?.exonereTva);
  const rate = exo ? 0 : Math.min(Math.max(Number(tauxTvaPercent) || 0, 0), 100);
  const tva = exo ? 0 : round2(sousTotalHT * (rate / 100));
  const totalTTC = round2(sousTotalHT + tva);

  return {
    sousTotalBrut: round2(sousTotalBrut),
    remiseTotale: round2(remiseTotale),
    sousTotalHT,
    tva,
    totalTTC,
    netAPayer: totalTTC,
  };
}
